/** Turn/step cost formatting shared by the meta strip and the details panel. */
export function formatCost(usd: number): string {
  // Cents range gets 4 decimals so $0.0034 doesn't round to $0.00.
  if (usd === 0) return "$0";
  if (usd < 0.01) return `$${usd.toFixed(6).replace(/0+$/, "").replace(/\.$/, "")}`;
  return `$${usd.toFixed(4)}`;
}
